import React from "react";

const Users = ({ width, height, color }) => {
  return (
    <svg
      width="26"
      height="20"
      viewBox="0 0 26 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 11.5C15.2091 11.5 17 9.82107 17 7.75C17 5.67893 15.2091 4 13 4C10.7909 4 9 5.67893 9 7.75C9 9.82107 10.7909 11.5 13 11.5Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5999 19C18.5999 17.6076 18.0099 16.2723 16.9597 15.2877C15.9095 14.3031 14.4851 13.75 12.9999 13.75C11.5147 13.75 10.0903 14.3031 9.0401 15.2877C7.9899 16.2723 7.3999 17.6076 7.3999 19H18.5999Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4002 8.5C20.082 8.5 20.7525 8.33661 21.3481 8.02533C21.9436 7.71406 22.4443 7.26524 22.8028 6.72149C23.1613 6.17775 23.3655 5.55712 23.3962 4.91856C23.4268 4.27999 23.2828 3.64468 22.9779 3.07295C22.673 2.50122 22.2172 2.01205 21.6539 1.6519C21.0906 1.29174 20.4385 1.07256 19.7594 1.01515C19.0803 0.957749 18.3969 1.06403 17.774 1.32391C17.151 1.58379 16.6093 1.98863 16.2002 2.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1999 16H24.9999C24.9999 14.6076 24.4099 13.2723 23.3597 12.2877C22.3095 11.3031 20.8851 10.75 19.3999 10.75"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.8001 2.5C9.391 1.98863 8.84927 1.58379 8.22633 1.32391C7.6034 1.06403 6.91995 0.957749 6.24088 1.01515C5.5618 1.07256 4.90966 1.29174 4.34636 1.6519C3.78306 2.01205 3.32731 2.50122 3.02239 3.07295C2.71747 3.64468 2.57349 4.27999 2.60414 4.91856C2.63479 5.55712 2.83904 6.17775 3.1975 6.72149C3.55595 7.26524 4.05672 7.71406 4.65224 8.02533C5.24776 8.33661 5.91827 8.5 6.6001 8.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6 10.75C5.11479 10.75 3.69041 11.3031 2.6402 12.2877C1.59 13.2723 1 14.6076 1 16H5.8"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Users;
